var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.034,
    height: 62.034,
    viewBox: "0 0 62.034 62.034",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    transform: "translate(-1375.982 -133.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M62.034,31.017A31.017,31.017,0,1,1,31.017,0,31.015,31.015,0,0,1,62.034,31.017",
    transform: "translate(1375.982 133.966)",
    fill: "#8fa2bb",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M19.742,15.857l-5.584-5.581,5.581-5.581A2.747,2.747,0,0,0,15.857.809L10.273,6.39,4.689.8A2.748,2.748,0,0,0,.8,4.689L6.39,10.276.815,15.847A2.747,2.747,0,0,0,4.7,19.733l5.575-5.575,5.587,5.584a2.747,2.747,0,1,0,3.883-3.886",
    transform: "translate(1396.726 154.71)",
    fill: "#8fa2bb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d0805c3605da6e96246f976afd2b6f35.svg";
export { ForwardRef as ReactComponent };